 <div class="today_chart_card">
    <mat-card appearance="outlined">
    <div class="vier_tht">
       <div class="heading_ot">
       <h3>Daily Sales </h3> 
      </div>
  </div>
  <div class="booking_chart" *ngIf="!loader && salesData.length > 0">
    <sm-line-chart-for-dashboard  [dataSource]="salesGraphData"></sm-line-chart-for-dashboard>
  </div> 
  <div class="placeholder_img_d" *ngIf="!loader && salesData.length == 0">
    <img src="../../../../../../../assets/images/chart-2.png" alt="Daily booking image"/>
   </div>  
</mat-card>
</div>